import { render, staticRenderFns } from "./OdpPaymentNoteModal.vue?vue&type=template&id=6a52184c"
import script from "./OdpPaymentNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OdpPaymentNoteModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports